import { render, staticRenderFns } from "./personalizationTeacher.vue?vue&type=template&id=6a488830&scoped=true"
import script from "./personalizationTeacher.vue?vue&type=script&lang=js"
export * from "./personalizationTeacher.vue?vue&type=script&lang=js"
import style0 from "./personalizationTeacher.vue?vue&type=style&index=0&id=6a488830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a488830",
  null
  
)

export default component.exports